// extracted by mini-css-extract-plugin
export default {"container":"ZoomSlider_container__OH93G","zoom_level":"ZoomSlider_zoom_level__snR9h"};